<template>
  <div v-loading="loading" element-loading-text="Loading...">
    <el-row class="text-info">
      <el-col :span="6" :md="3" :lg="6" v-for="(field, index) in fields" :key="index" class="text-info-col">
        <el-form ref="textInfo">
          <el-form-item :label="field.label" class="text-info-form-item">
            <el-input
                :value="getFieldDisplayValue(field.model)"
                disabled
                class="small-input"
            ></el-input>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>


<script>
export default {
  props: {
    infoData: {
      type: Array,
      required: true,
    },
    loading: Boolean  // 接收 loading 状态
  },
  data() {

    return {
      localInfoData: this.infoData,
      fields: [
        {label: this.$t('ProcessAfterSale.customerName'), model: 'customer_name'},
        {label: this.$t('ProcessAfterSale.country'), model: 'country'},
        {label: this.$t('ProcessAfterSale.address'), model: 'address'},
        {label: this.$t('ProcessAfterSale.brandEBike'), model: 'brand'},
        {label: this.$t('ProcessAfterSale.phone'), model: 'phone'},
        {label: this.$t('ProcessAfterSale.pickupAddress'), model: 'delivery_address'},
        {label: this.$t('ProcessAfterSale.email'), model: 'email'},
        {label: this.$t('ProcessAfterSale.contactPerson'), model: 'contact_person'},
        {label: this.$t('ProcessAfterSale.market'), model: 'market'},
        {label: this.$t('ProcessAfterSale.dealerName'), model: 'dealer_name'},

      ],
    };
  },
  watch: {
    infoData(newInfoData) {
      this.localInfoData = newInfoData;
    },
  },
  methods: {
    getFieldDisplayValue(fieldModel) {
      // 将 infoData 数组转换为对象，方便按字段名查找
      const dataObject = this.localInfoData.reduce((acc, item) => {
        return { ...acc, ...item };
      }, {});
      
      const value = dataObject[fieldModel];
      
      // 处理 market 字段的特殊转换
      if (fieldModel === 'market') {
        const marketOptions = [
          { label: 'WESTERN_EUROPE', value: this.$t('ApplyAfterSales.westernEurope') },
          { label: 'CENTRAL_EUROPE', value: this.$t('ApplyAfterSales.centralEurope') },
          { label: 'EASTERN_EUROPE', value: this.$t('ApplyAfterSales.easternEurope') },
          { label: 'NORTH_AMERICA', value: this.$t('ApplyAfterSales.northAmerica') },
          { label: 'SOUTH_AMERICA', value: this.$t('ApplyAfterSales.southAmerica') },
          { label: 'ASIA_PACIFIC', value: this.$t('ApplyAfterSales.asiaPacific') },
          { label: 'CHINA', value: this.$t('ApplyAfterSales.china') },
          { label: 'AFRICA', value: this.$t('ApplyAfterSales.africa') }
        ];
        
        const option = marketOptions.find(opt => opt.label === value);
        const looseOption = option ? null : marketOptions.find(opt => opt.label == value);
        
        return option ? option.value : (looseOption ? looseOption.value : value);
      }
      
      // 处理空值：null、undefined、空字符串都显示为 '-'
      if (value === null || value === undefined || value === '') {
        return '-';
      }
      
      return value;
    }
  },
};
</script>

<style scoped>
.text-info-col {
  padding-left: 10px;
  margin-bottom: 5px;
}

.small-input {
  width: 80%;
}

.text-info {
  margin-top: 20px;
}
</style>
